import { path, split } from 'ramda';
import hasError from './hasError';

const getErrorMessage = (errors, name) => {
  if (hasError(errors, name)) {
    const errorPath = split('.', name);
    const errorMessage = path(errorPath, errors);
    return errorMessage.message;
  }

  return null;
};

export default getErrorMessage;
